// TODO: This is a too-minimal and too-technically oriented error page. Needs replaced with something more generic
// and brand-friendly before release

import { Button } from '@platform/components';
import MovingWorldsCompassLogo from './app/layout/MovingWorldsCompassLogo';
import { HeaderFooterLayout } from './app/app';

// From the basic tutorial https://reactrouter.com/en/main/start/tutorial#handling-not-found-errors
const ErrorPage = () => {
  return (
    <HeaderFooterLayout>
      <div className='my-12 flex flex-col mx-auto py-24 items-center w-[700px] gap-10 text-center'>
        <div className='w-32 h-32 text-brand-500'>
          <MovingWorldsCompassLogo />
        </div>
        <span className='text-2xl'>
          We're sorry! Something went wrong. <br /> Please try again or contact support
        </span>
        <Button
          size='2xl'
          variant='primary'
          onPress={() => {
            window.open('https://zsupport.movingworlds.org/portal/newticket', '_blank');
          }}
        >
          Contact Us For Assistance
        </Button>
      </div>
    </HeaderFooterLayout>
  );
};

export default ErrorPage;
